import { useTranslation } from "react-i18next";
import { sourceNames } from "../workflowData/models";
import type { WorkflowContextSelector } from "../../components/NoteWorkflows/noteWorkflowsTypes";
import styles from "./WorkflowBuilder.module.css";

export function ProjectSourceBadges({ selectors }: { selectors: readonly WorkflowContextSelector[] }) {
    const { t } = useTranslation();
    return <>{selectors.map(selector => <p key={selector} className={styles.contextBadge}>
        {t(`workflowData.source_${selector}`, { defaultValue: sourceNames[selector] })}
    </p>)}</>;
}
